import React from "react";

import './fcresult.css';

const OpenfiberResult = (props) => {

    const civic = props.civic;
    const details = props.data.OF.details.records[0];

    return(
        (civic.length > 0) ?
        <div style={{width: '60%', margin: 'auto'}}>
            <h2 style={{textAlign: 'center'}}>Dettagli</h2>
            <table style={{border: '1px solid #dee2e6'}} className="dataTable">
                <tr>
                    <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>Cluster</td>
                    <td>{details.cluster}</td>
                </tr>
                <tr>
                    <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>POP</td>
                    <td>{details.POP}</td>
                </tr>
                <tr>
                    <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>Posizione</td>
                    <td>                            
                        <a target="_blank" rel="noopener noreferrer" href={`https://www.google.com/maps/search/?api=1&query=${details.COORDINATE_BUILDING.replace("_","")}`}>
                            Maps
                        </a>    
                    </td>
                </tr>
            </table>
        </div>
        :
        <div style={{width: '60%', margin: 'auto'}}>
        <h2 style={{textAlign: 'center'}}>Dettagli</h2>
        <table style={{border: '1px solid #dee2e6'}} className="dataTable">
            <tr>
                <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>Cluster</td>
                <td>{details.cluster}</td>
            </tr>
        </table>
    </div>

    )
}

export default OpenfiberResult;